import React from "react";
import "./StatusCard.css";

const StatusCard = ({ title, value, subText, badge }) => {
  return (
    <div className="stats-card">
      <p className="stats-title">{title}</p>
      <h2 className="stats-value">{value}</h2>

      {(badge || subText) && (
        <div className="stats-meta">
          {badge && <span className="stats-badge">{badge}</span>}
          {subText && <span className="stats-subtext">{subText}</span>}
        </div>
      )}
    </div>
  );
};

export default StatusCard;










